import Enum from '@/utils/Enum';

const InitialSortTypeEnum = {
	MODIFIED_ON: new Enum('-modifiedOn', 'modifiedOn'),
	INPUT_PHRASE: new Enum('inputPhrase', 'inputPhrase'),
	NAME: new Enum('name', 'name'),
	SURNAME: new Enum('surname', 'surname'),
};

export default InitialSortTypeEnum;